@if (forms) {
  <section class="astral-sortable-file-upload">
    <div class="astral-sortable-file-upload__grid" cdkDropListGroup>
      <div cdkDropList (cdkDropListEntered)="onDropListEntered($event)" (cdkDropListDropped)="onDropListDropped()"></div>
      @for (form of $any(forms.controls); track form) {
        <div
          class="astral-sortable-file-upload__item"
          cdkDropList
          [cdkDropListDisabled]="maxFiles === 1 || readonly"
          (cdkDropListEntered)="onDropListEntered($event)"
          (cdkDropListDropped)="onDropListDropped()"
          >
          <div class="draggable-container">
            <div class="doc-container">
              @if (!readonly) {
              <button class="delete-file" type="button" [attr.aria-label]="'DELETE_BTN' | translate" [title]="'DELETE_BTN' | translate" (click)="delete(form)">
                <img src="assets/icons/component_icons/close-white.png" alt="" aria-hidden="true" />
              </button>
              }
              <div
                class="img-wrap"
                [cdkDragDisabled]="maxFiles === 1 || readonly"
                [cdkDragStartDelay]="enableDragDelay ? 50 : 0"
                cdkDrag
                cdkDragRootElement=".draggable-container"
              >
                <div class="icon" [ngClass]="getClass(form.controls['mimeType'].value)"></div>
                @if (showImage(form.controls['mimeType'].value)) {
                  <img
                    [src]="form.controls['src'].value"
                    [alt]="form.controls['title'].value"
                    />
                }
              </div>
              <astral-input (mousedown)="cancel($event)" [control]="form.controls['title']"></astral-input>
            </div>
          </div>
        </div>
      }
      @if (fileCount < maxFiles && !readonly) {
        <div class="astral-sortable-file-upload__add">
          @if (externalClickEvent) {
            <app-single-file-upload
              [autoReset]="true"
              [allowedMimeTypes]="allowedMimeTypes"
              (filesSelected)="onFileChange($event)"
              [externalClickEvent]="externalClickEvent"
              [ngStyle]="{ visibility: 'hidden' }"
            ></app-single-file-upload>
          }
          @if (!externalClickEvent) {
            <app-single-file-upload
              [autoReset]="true"
              [allowedMimeTypes]="allowedMimeTypes"
              (filesSelected)="onFileChange($event)"
            ></app-single-file-upload>
          }
        </div>
      }
    </div>
    <div>
      @if (fileCount > maxFiles && !readonly) {
        <p class="error-text">
          {{ 'ERROR.MAX_FILES_LIMIT_BREACHED' | translate: { maxFiles: maxFiles, fileCount: fileCount } }}
        </p>
      }
    </div>
  </section>
}
